import http, { catach_url, httpCache } from './index'
catach_url.push({
    url: "/api/Account/Login",
    count: 5
})

export default function login(data) {
    return httpCache({
        method: "POST",
        url: "/api/Account/Login",
        params: data,
        data: JSON.stringify(data),
        headers: { "content-type": "application/json" }
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js